import { useMemo } from 'react'

import { getBusinessLabel } from 'pared/customer'
import { getBrand } from 'pared/utils/brand'
import { getUser } from 'pared/utils/user'

export interface ILocationGroupType {
  id: number
  name: string
}

interface IConfig {
  locationGroupTypes: ILocationGroupType[]
  shouldHideGroups?: boolean
  isDirectorBreakdownVisible: boolean
}

const defaultConfig = {
  locationGroupTypes: [],
  shouldHideGroups: true,
  isDirectorBreakdownVisible: true,
}

const useConfig = (): IConfig => {
  const brand = getBrand()
  const user = getUser()
  return useMemo(() => {
    switch (brand) {
      case 'cava':
        return {
          ...defaultConfig,
          locationGroupTypes: [
            {
              id: -3,
              name: 'RD',
            },
            {
              id: -4,
              name: 'Garden',
            },
            {
              id: -5,
              name: 'Multi-Unit',
            },
          ],
          shouldHideGroups: user.isStoreLevelUser,
          isDirectorBreakdownVisible: false,
        }
      case 'supreme_bk':
        return {
          ...defaultConfig,
          locationGroupTypes: [
            {
              id: -3,
              name: 'Division',
            },
          ],
          shouldHideGroups: false,
        }
      case 'mbn_bk':
        return {
          ...defaultConfig,
          locationGroupTypes: [
            {
              id: -3,
              name: 'DO',
            },
          ],
          shouldHideGroups: false,
        }
      case 'jsc_bk':
      case 'jsc_bk_nso':
        return {
          ...defaultConfig,
          locationGroupTypes: [
            {
              id: -5,
              name: 'Comp or Non-Comp',
            },
            {
              id: -3,
              name: 'Region',
            },
          ],
          shouldHideGroups: false,
        }
      case 'irmg_pop':
      case 'ghai_pop':
      case 'demo_pop':
        return {
          ...defaultConfig,
          locationGroupTypes: [
            {
              id: -3,
              name: 'Area Director',
            },
          ],
          shouldHideGroups: false,
        }
      case 'supreme_pop':
        return {
          ...defaultConfig,
          locationGroupTypes: [
            {
              id: -2,
              name: getBusinessLabel('director'),
            },
            {
              id: -3,
              name: 'Regional Manager',
            },
            {
              id: -4,
              name: 'State',
            },
            {
              id: -5,
              name: 'District',
            },
          ],
          shouldHideGroups: false,
        }
      case 'bibibop':
        return {
          ...defaultConfig,
          locationGroupTypes: [
            {
              id: -3,
              name: 'Comp or Non-Comp',
            },
            {
              id: -2,
              name: getBusinessLabel('director'),
            },
            {
              id: -4,
              name: 'Region',
            },
            {
              id: -5,
              name: 'Market',
            },
            {
              id: -6,
              name: 'Multi-Unit Manager',
            },
            {
              id: -7,
              name: 'State',
            },
            {
              id: -8,
              name: 'City',
            },
          ],
          shouldHideGroups: false,
        }
      case 'mwb':
        return {
          ...defaultConfig,
          locationGroupTypes: [
            {
              id: -4,
              name: getBusinessLabel('director'),
            },
            {
              id: -5,
              name: 'Comp or Non-Comp',
            },
            {
              id: -6,
              name: 'State',
            },
          ],
          shouldHideGroups: false,
        }
      case 'burgerworks':
        return {
          ...defaultConfig,
          locationGroupTypes: [
            {
              id: -3,
              name: 'Area Coach',
            },
            {
              id: -4,
              name: getBusinessLabel('director'),
            },
            {
              id: -5,
              name: 'Comp or Non-Comp',
            },
          ],
          shouldHideGroups: false,
        }

      case 'fw_wingstop':
        return {
          ...defaultConfig,
          locationGroupTypes: [
            {
              id: -2,
              name: getBusinessLabel('director'),
            },
            {
              id: -3,
              name: 'RO',
            },
            {
              id: -4,
              name: 'Market',
            },
            {
              id: -5,
              name: 'State',
            },
            {
              id: -6,
              name: 'Comp or Non-Comp',
            },
            {
              id: -7,
              name: 'Core or Non-Core',
            },
          ],
          shouldHideGroups: false,
        }
      case 'ace_pop':
        return {
          ...defaultConfig,
          locationGroupTypes: [
            {
              id: -2,
              name: getBusinessLabel('director'),
            },
            {
              id: -3,
              name: 'State',
            },
            {
              id: -4,
              name: 'Legacy or Acquisition',
            },
          ],
          shouldHideGroups: false,
        }

      case 'wingitnorth':
        return {
          ...defaultConfig,
          locationGroupTypes: [
            {
              id: -3,
              name: getBusinessLabel('director'),
            },
            {
              id: -4,
              name: 'DO',
            },
          ],
          shouldHideGroups: Boolean(user.isStoreLevelUser),
          isDirectorBreakdownVisible: false,
        }

      default:
        return defaultConfig
    }
  }, [brand])
}

export default useConfig
